var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('OrderedList',{attrs:{"name":_vm.translate('What\'s new in') + ' v 2.0',"list":_vm.getAppV20Description()}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }